import { useCallback } from 'react';

import { IDatahubTask, TaskCategory } from 'api';
import { MODALS_STORE, TASKS_MODAL_ID } from 'constants/ui/modal';

const useOpenTasksModal = () => {
  const { toggleModal } = MODALS_STORE.tasks();

  return useCallback(
    (task: IDatahubTask) => {
      switch (task.type) {
        case TaskCategory.Basic:
        case TaskCategory.BasicOpt:
          toggleModal(TASKS_MODAL_ID.INPUT_TEXT, { task });
          break;
        case TaskCategory.UploadImages:
        case TaskCategory.UploadVideos:
          toggleModal(TASKS_MODAL_ID.UPLOAD, { task });
          break;
        case TaskCategory.Text:
        case TaskCategory.NoStyleText:
          toggleModal(TASKS_MODAL_ID.TEXT, { task });
          break;
        case TaskCategory.AITextInput:
          toggleModal(TASKS_MODAL_ID.AITextInput, { task, aiTextInput: { activeStep: 0 } });
          break;
        case TaskCategory.AITextOverview:
          toggleModal(TASKS_MODAL_ID.AITextOverview, { task });
          break;
        case TaskCategory.ImageSelector:
        case TaskCategory.WhiteboxImageSelector:
          toggleModal(TASKS_MODAL_ID.IMAGE_SELECTORS, {
            task,
            endpoint: task.type === TaskCategory.ImageSelector ? 'imageselector' : 'whitebox-imageselector',
          });
          break;
        case TaskCategory.VirtualStagingIndoorRenovation:
        case TaskCategory.VirtualStagingOutdoorRenovation:
        case TaskCategory.VirtualStagingRemoveObjects:
          toggleModal(TASKS_MODAL_ID.RETOUCHING_IMAGE, { task });
          break;
        case TaskCategory.BeforeAfter:
        case TaskCategory.SomeGif:
          toggleModal(TASKS_MODAL_ID.BEFORE_AFTER, {
            task,
            endpoint: task.type === TaskCategory.SomeGif ? 'some-gif' : 'beforeafter',
          });
          break;
        case TaskCategory.VirtualStaging:
        case TaskCategory.VirtualStagingCommercial:
        case TaskCategory.VirtualStaging720:
        case TaskCategory.VirtaulStagingCommercial720:
          toggleModal(TASKS_MODAL_ID.VIRTUAL_STAGING_PICTURE, {
            task,
            materialType:
              task.type === TaskCategory.VirtualStaging || task.type === TaskCategory.VirtualStagingCommercial
                ? 'Picture'
                : 'PanoramasHtml5',
            virtualStaging: {
              activeStep: 0,
            },
          });
          break;
        default:
          toggleModal(TASKS_MODAL_ID[task.type], { task });
          return;
      }
    },
    [toggleModal]
  );
};

export default useOpenTasksModal;
